$(function () {
  var mobileHeader = $(".mobile-width");
  var headerInner = $(".header-top-inner");

  var mobileNavMenu = $(".mobile-navmenu.hidden-xl-up");
  var headerDesktop = $(".header-top.site-header-inner.hidden-xl-down");

  var headerMarker = $(".header-marker-height");
  var topMobile = mobileHeader.offset().top;

  
$(window).scroll(function () {
  // Check if mobile-menu-overlay3 or mobile-menu-overlay2 is not active
  if (!($(".mobile-menu-overlay3").hasClass("active") ||
        $(".mobile-menu-overlay2").hasClass("active") || 
        $(".mobile-menu-overlay").hasClass("active") ||
        $(".toggle-dropdown").hasClass("active") ||
        $(".toggle-localization").hasClass("active") ||
        $(".toggle-dropdown1").hasClass("active"))) {
    // Proceed with the scroll handling only if the overlays are not active
    if ($(window).width() <= 1199) {
      if ($(window).scrollTop() > topMobile) {
        mobileNavMenu.addClass("fixed-header");
        headerMarker.addClass("header-marker-height-active");
      } else {
        mobileNavMenu.removeClass("fixed-header");
        headerMarker.removeClass("header-marker-height-active");
      }
    }
  }
});


  var topDesktop = headerInner.offset().top;

$(window).scroll(function () {
  // Check if mobile-menu-overlay3 or mobile-menu-overlay2 is not active
  if (!($(".mobile-menu-overlay3").hasClass("active") ||
        $(".mobile-menu-overlay2").hasClass("active") || 
        $(".mobile-menu-overlay").hasClass("active") ||
        $(".toggle-dropdown").hasClass("active") ||
        $(".toggle-localization").hasClass("active") ||
        $(".toggle-dropdown1").hasClass("active"))) {
  // Proceed with the scroll handling only if the overlays are not active
    if ($(window).width() >= 1200) {
      if ($(window).scrollTop() > topDesktop) {
        headerDesktop.addClass("fixed-header");
        headerInner.addClass("fixed-header");
        headerMarker.addClass("header-marker-height-active");
      } else {
        headerDesktop.removeClass("fixed-header");
        headerInner.removeClass("fixed-header");
        headerMarker.removeClass("header-marker-height-active");
      }
    }
  }
});


});



